import './list.scss';
import Sidebar from '../../components/sidebar/Sidebar';
import Navbar from '../../components/navbar/Navbar';
import PdfDesignListScreen from '../../components/forms/PdfDesignListScreen';
import { useSidebarState } from '../../components/sidebar/SidebarStateContext';

const PdfDesigns = () => {
  const { collapsed } = useSidebarState();
  const containerClass = collapsed ? 'listContainer collapsed' : 'listContainer';

  return (
    <div className="list">
      <Sidebar />
      <div className={containerClass}>
        <Navbar />
        <PdfDesignListScreen />
      </div>
    </div>
  );
};

export default PdfDesigns;
